<template>
  <div class="interaction-container">
    <div class="label">
      <span>{{ label }}</span>
    </div>
    <div class="radio-options">
      <label v-for="option in this.options"
        :key="option"
        class="radio-option"
        :class="{ active: displayedOption === option }"
        :data-option-val="option">
        <input type="radio" name="radio-input" 
          :checked="displayedOption === option"       
          @change="handleOptionChanged(option)" />
        <span class="custom-radio"><span></span></span>
        <span>{{ option }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomizerRadio",
  props: {
    label: {
      type: String,
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    valueTypeFunction: {
      type: String,
    },
    windowEvent: {
      type: String,
    },
  },
  data() {
    return {
      displayedOption: null,
    };
  },
  mounted() {
    // document.addEventListener('option-changed-resize', () => this.updateBoxSize())
  },
  created() {
    this.displayedOption = this.activeOption;
  },
  computed: {
    options() {
      return this.$store.getters[this.optionFunction];
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction];
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction];
    },
    valueType() {
      return this.$store.getters[this.valueTypeFunction];
    },
  },
  methods: {
    handleOptionChanged(option) {
      if (option != this.displayedOption) {
        this.displayedOption = option;
      this.$store.dispatch(this.setFunction, option);
      if (this.windowEvent) {
        window.dispatchEvent(new CustomEvent(this.windowEvent, {detail: option}));
      }
      this.$emit("option-changed");
      }
    },
  },
};
</script>

<style scoped>
.radio-options label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  min-width: unset;
}
.radio-options input {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-radio {
  float: left;
  width: 15px;
  height: 15px;
  margin: 0 5px 0 0;
  vertical-align: middle;
  cursor: pointer;
  background-repeat: no-repeat;
  border: 1px solid rgba(0, 0, 0, .3);
  border-radius: 100%;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  position: relative;
}
input:checked+.custom-radio:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 11px;
  height: 11px;
  background-color: #000c;
  border-radius: 50%;
}
.radio-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
@media screen and (min-width: 768px) {
  .radio-options {
    display: flex;
    gap: 20px;
  }
}
</style>
